<ng-container *tuiLet="items$ | async as items">
  <ng-container *tuiLet="(isMobileRes$ | async) && !forceTypeahead as isSelect">
    <ng-container *ngIf="multi">
      <tui-multi-select
        [formControl]="control.control"
        [tuiTextfieldLabelOutside]="true"
        [readOnly]="!!readonly"
        [valueContent]="selectedValueContent"
        [placeholder]="placeholder"
        issDoNotClearOnSearch
        [(search)]="search"
        (focusedChange)="onFocusChange($event)"
      >
        <ng-container [ngTemplateOutlet]="placeholderTpl"/>
        <ng-template tuiDataList tuiMultiSelectGroup>
          <tui-data-list *ngIf="(loading$ | async | isFalse); else loadingTpl">
            <iss-multiselect-all *ngIf="withAll else optionsTpl">
              <button
                *ngFor="let item of items | tuiFilterByInputWith: matcher"
                tuiOption
                [value]="identity(item)"
                class="tw-w-full"
              >
                <ng-container
                  [ngTemplateOutlet]="itemDirective?.templateRef || valueContent"
                  [ngTemplateOutletContext]="{ $implicit: identity(item), item }"
                />
              </button>
            </iss-multiselect-all>
            <ng-template #optionsTpl>
              <button
                *ngFor="let item of items | tuiFilterByInputWith: matcher"
                tuiOption
                [value]="identity(item)"
                class="tw-w-full"
              >
                <ng-container
                  [ngTemplateOutlet]="itemDirective?.templateRef || valueContent"
                  [ngTemplateOutletContext]="{ $implicit: identity(item), item }"
                />
              </button>
            </ng-template>
            <ng-container [ngTemplateOutlet]="projected"/>
          </tui-data-list>
        </ng-template>
      </tui-multi-select>
      <ng-template #selectedValueContent let-data>
        {{ data.length ? data.length + ' selected' : '' }}
      </ng-template>
    </ng-container>
    <ng-container *ngIf="!multi">
      <tui-select
        *ngIf="isSelect"
        [formControl]="control.control"
        [tuiTextfieldLabelOutside]="true"
        [tuiTextfieldCleaner]="clearable"
        [readOnly]="!!readonly"
        [valueContent]="valueContent"
      >
        <ng-container [ngTemplateOutlet]="placeholderTpl"/>
        <ng-template tuiDataList>
          <tui-data-list *ngIf="(loading$ | async | isFalse); else loadingTpl">
            <button
              *ngIf="withAll"
              tuiOption
              [value]="'ALL'"
            >
              All
            </button>
            <button
              *ngFor="let item of items"
              tuiOption
              [value]="identity(item)"
            >
              <ng-container
                [ngTemplateOutlet]="itemDirective?.templateRef || valueContent"
                [ngTemplateOutletContext]="{ $implicit: identity(item), item }"
              />
            </button>
            <ng-container [ngTemplateOutlet]="projected"/>
          </tui-data-list>
        </ng-template>
      </tui-select>
      <tui-combo-box
        *ngIf="!isSelect"
        [formControl]="control.control"
        [tuiTextfieldLabelOutside]="true"
        [tuiTextfieldCleaner]="clearable"
        [readOnly]="!!readonly"
        [valueContent]="valueContent"
        [stringify]="stringify(items)"
        [clearable]="clearable"
      >
        <ng-container [ngTemplateOutlet]="placeholderTpl"/>
        <ng-template tuiDataList>
          <tui-data-list *ngIf="(loading$ | async | isFalse); else loadingTpl">
            <button
              *ngIf="withAll"
              tuiOption
              [value]="'ALL'"
            >
              All
            </button>
            <button
              *ngFor="let item of items | tuiFilterByInputWith: matcher"
              tuiOption
              [value]="identity(item)"
            >
              <ng-container
                [ngTemplateOutlet]="itemDirective?.templateRef || valueContent"
                [ngTemplateOutletContext]="{ $implicit: identity(item), item }"
              />
            </button>
            <ng-container [ngTemplateOutlet]="projected"/>
          </tui-data-list>
        </ng-template>
      </tui-combo-box>
    </ng-container>
    <ng-template #valueContent let-value>
      {{ content(value, items) }}
    </ng-template>
    <ng-template #loadingTpl>
      <tui-loader [size]="'s'" />
    </ng-template>
  </ng-container>
</ng-container>

<ng-template #projected>
  <ng-content/>
</ng-template>

<ng-template #placeholderTpl>
  <div class="tw-flex tw-items-center tw-justify-between">
    <div><span *ngIf="isEmpty">{{ placeholder }}</span></div>
    <tui-loader *ngIf="loading || ((loading$ | async) && control.control.value)" [size]="'s'" class="tw-w-[24px]" />
  </div>
</ng-template>
